import { render } from "./RewardDisplay.vue?vue&type=template&id=399d66c4&ts=true"
import script from "./RewardDisplay.vue?vue&type=script&lang=ts"
export * from "./RewardDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__